import React, { useState, useEffect } from "react";
import moment from "moment";
import {
  getAllReviews,
  deleteReview,
  updateReview,
  addReview
} from "../Common/apis";

const CourseReview = ({ course }) => {
  const courseId = course?._id;
  const [reviews, setReviews] = useState([]);
  const [formData, setFormData] = useState({ rating: "", comment: "" });
  const [editingReview, setEditingReview] = useState(null);
  const userData = JSON.parse(localStorage.getItem("GISUL_USER")) || {};

  // Modal toggle state
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (courseId) {
      fetchReviews();
    }
  }, [courseId]);

  const fetchReviews = async () => {
    try {
      const res = await getAllReviews(courseId);
      setReviews(res?.data || []);
    } catch (err) {
      console.error("Error fetching reviews", err);
    }
  };

  const handleSubmit = async () => {
    try {
      if (editingReview) {
        await updateReview(formData, courseId, editingReview._id);
      } else {
        await addReview(formData, courseId);
      }
      fetchReviews();
      setShowModal(false);
      setFormData({ rating: "", comment: "" });
      setEditingReview(null);
    } catch (err) {
      console.error("Error submitting review", err);
    }
  };

  const handleDelete = async (reviewId) => {
    try {
      if (!window.confirm("Are you sure you want to delete this review?")) {
        return;
      }
      await deleteReview(courseId, reviewId);
      fetchReviews();
    } catch (err) {
      console.error("Error deleting review", err);
    }
  };

  const openEditModal = (review) => {
    setEditingReview(review);
    setFormData({ rating: review.rating, comment: review.comment });
    setShowModal(true);
  };

  return (
    <>
      <div
        className="bg-[#6953A3B2] rounded-[16px] p-[28px]"
        style={{ backdropFilter: "blur(20px)" }}
      >
        <div className="pb-[20px] flex justify-between items-center">
          <h6 className="font-[700] font-sans text-[24px] leading-[36px] text-[#FFFFFF]">
            Reviews
          </h6>
          <button className="btn btn-light" onClick={() => setShowModal(true)}>
            Add Review
          </button>
        </div>

        <div className="grid grid-cols-1 gap-[20px]">
          {reviews.map((e, i) => (
            <div key={i}>
              <div className="bg-[#F7F7F9] rounded-[16px] p-[20px]">
                <div className="flex justify-between pb-[22px] items-center">
                  <div className="flex items-center gap-[12px]">
                    <img src="/assets/slider/img5.png" alt="" />
                    <div>
                      <h6 className="text-[20px] font-[400] text-[#000000] font-sans">{e?.name}</h6>
                      <p className="text-[16px] font-[400] font-sans text-[#000000]">
                        {moment(e?.updatedAt).fromNow()}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center">
                    {[...Array(e?.rating)].map((_, i) => (
                      <img
                        key={i}
                        src="/assets/slider/single-star.svg"
                        alt="star"
                      />
                    ))}
                    {userData?._id === e?.user && (
                      <>
                        <button
                          className="btn btn-sm btn-warning"
                          onClick={() => openEditModal(e)}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(e._id)}
                        >
                          Delete
                        </button>
                      </>
                    )}
                  </div>
                </div>
                <div
                  dangerouslySetInnerHTML={{ __html: e?.comment }}
                  className="text-[14px] font-sans font-[400] text-[#505050]"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bootstrap Modal */}
      {showModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "#00000080" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {editingReview ? "Edit Review" : "Add Review"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                {/* <label className="form-label">Rating (1 to 5)</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={formData.rating}
                  min="1"
                  max="5"
                  onChange={(e) =>
                    setFormData({ ...formData, rating: e.target.value })
                  }
                /> */}
                <label className="form-label d-block mb-2">Rating</label>
                <div className="mb-3">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <i
                      key={star}
                      className={`bi ${
                        star <= formData.rating ? "bi-star-fill" : "bi-star"
                      }`}
                      style={{
                        fontSize: "24px",
                        color: "#FFD700", // Gold color
                        cursor: "pointer",
                        marginRight: "5px"
                      }}
                      onClick={() => setFormData({ ...formData, rating: star })}
                    ></i>
                  ))}
                </div>

                <label className="form-label">Comment</label>
                <textarea
                  className="form-control"
                  value={formData.comment}
                  onChange={(e) =>
                    setFormData({ ...formData, comment: e.target.value })
                  }
                />
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={handleSubmit}>
                  {editingReview ? "Update" : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CourseReview;
